module.exports = {
    bindings: {
        measures: '<'
    },
    templateUrl: 'good/components/export-measures.html'
};
